"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _zhjySerach = _interopRequireDefault(require("@/components/search/zhjySerach.vue"));
var _funBtn = _interopRequireDefault(require("@/components/funBtn/funBtn.vue"));
var _zhjyTable = _interopRequireDefault(require("@/components/table/zhjyTable.vue"));
var _zhjyPagination = _interopRequireDefault(require("@/components/zhjyPagination/zhjyPagination.vue"));
var _project = require("@/api/project/project");
var _validate = require("@/libs/validate1.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      adminForm: {
        name: "",
        phoneNumber: "",
        mail: "",
        schoolId: "",
        idCard: "",
        loginName: "",
        userType: 4,
        isExpert: 0,
        isPlatUser: 0
      },
      back1: false,
      adminDia: false,
      funBtns: [{
        size: "small",
        click: "add",
        icon: "el-icon-circle-check",
        name: "新增",
        type: "primary"
      }, {
        size: "small",
        click: "del",
        icon: "el-icon-circle-check",
        name: "批量删除",
        type: "primary"
      }],
      queryGroup: [{
        label: "精确查找",
        type: "input",
        model: "queryValue",
        placeholder: "管理员姓名"
      }],
      modelData: {
        queryValue: ""
      },
      defaultColumn: [{
        name: "管理员姓名",
        prop: "name",
        isShow: true,
        width: "200"
      }, {
        name: "登录账号",
        prop: "loginName",
        isShow: true,
        width: "200"
      },
      // {
      //   name: "所属学校",
      //   prop: "matchTypeName",
      //   isShow: true,
      //   width: "200"
      // },
      {
        name: "邮箱",
        prop: "mail",
        isShow: true,
        width: "200"
      }, {
        name: "电话",
        prop: "phoneNumber",
        isShow: true,
        width: "200"
      }, {
        name: "所属学校",
        prop: "schoolName",
        isShow: true,
        width: "200"
      }, {
        name: "创建时间",
        prop: "createTime",
        // isShow: true,
        width: "300",
        sortable: true
      }],
      minWidth: 300,
      page: {
        pageNumber: 1,
        pageSize: 10
      },
      totalData: 0,
      listData: [],
      formatters: {
        belongAdministrator: []
      },
      sort: {
        prop: "",
        order: ""
      },
      checkBoxs: [],
      searchName: "",
      options: [{
        name: "重置密码",
        class: "editor",
        option: "reset",
        span: 5
      }, {
        name: "删除",
        class: "editor",
        option: "del",
        span: 5
      }],
      rules: {
        name: [{
          required: true,
          message: "请输入管理员姓名",
          trigger: "blur"
        }, {
          min: 2,
          max: 12,
          message: "长度在 2 到 12 个字符",
          trigger: "blur"
        }],
        uniqueCode: [{
          required: true,
          message: "请输入编号",
          trigger: "blur"
        }],
        idCard: [
        // { required: true, message: "请输入身份证号", trigger: "blur" },
        {
          validator: _validate.validateIdNo,
          trigger: "blur"
        }],
        loginName: [{
          required: true,
          message: "请输入登录账号",
          trigger: "blur"
        }, {
          min: 2,
          max: 30,
          message: "长度在 2 到 30 个字符",
          trigger: "blur"
        }],
        phoneNumber: [{
          required: true,
          message: "请输入手机号",
          trigger: "blur"
        }, {
          validator: _validate.validatePhoneTwo,
          trigger: "blur"
        }],
        mail: [{
          required: true,
          message: "请输入邮箱",
          trigger: "blur"
        }, {
          validator: _validate.validateEMail,
          trigger: "blur"
        }],
        schoolId: [{
          required: true,
          message: "请选择所属学校",
          trigger: "change"
        }]
      },
      schoolList: []
    };
  },
  methods: {
    // 新增按钮
    add: function add() {
      this.adminDia = true;
    },
    delDia: function delDia() {
      this.adminDia = false;
    },
    // 添加管理员
    saveAdmin: function saveAdmin(v) {
      var _this = this;
      console.log(this.adminForm);
      this.$refs[v].validate(function (valid) {
        if (valid) {
          (0, _project.addAdminList)(_this.adminForm).then(function (res) {
            _this.$message.success("操作成功。");
            _this.adminDia = false;
            _this.getAdminList();
          });
        }
      });
    },
    // 模糊搜索
    search: function search(v) {
      this.searchName = v.queryValue;
      this.getAdminList();
    },
    //获取省项目管理员列表
    getAdminList: function getAdminList() {
      var _this2 = this;
      (0, _project.findObjectAdminList)({
        param: this.searchName,
        pageSize: this.page.pageSize,
        pageNum: this.page.pageNumber
      }).then(function (res) {
        var data = res.data;
        _this2.listData = data.list;
        _this2.totalData = data.total;
      });
    },
    // 新增
    save: function save() {
      if (this.prCode === "guizhou") {
        this.$router.push("/object/objectGZ-add");
      } else {
        this.$router.push("/object/object-add");
      }
    },
    // 编辑
    reset: function reset(row) {
      var _this3 = this;
      this.$confirm("确认重置吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.resetPass)({
          id: row.id
        }).then(function () {
          _this3.getAdminList();
          _this3.$message.success("操作成功。");
        });
      }).catch(function () {
        _this3.$message.info("取消重置。");
      });
    },
    handleSelectionChange: function handleSelectionChange(e) {
      var _this4 = this;
      this.checkBoxs = [];
      e.forEach(function (item) {
        _this4.checkBoxs.push(item.id);
      });
    },
    // 删除管理员
    del: function del(row) {
      var _this5 = this;
      var idList = [];
      if (!row && this.checkBoxs.length === 0) {
        return this.$message.error("请先勾选数据");
      } else if (row) {
        idList.push(row.id);
      } else if (this.checkBoxs.length > 0) {
        idList = this.checkBoxs;
      }
      this.$confirm("确认删除吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true
      }).then(function () {
        (0, _project.delAdmin)({
          idList: idList
        }).then(function () {
          _this5.getAdminList();
          _this5.$message.success("操作成功。");
        });
      }).catch(function () {
        _this5.$message.info("取消删除。");
      });
    },
    handleCurrentChange: function handleCurrentChange(e) {
      this.page.pageNumber = e;
      this.getAdminList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.page.pageSize = e;
      this.page.pageNumber = 1;
      this.getAdminList();
    },
    // 获取学校列表
    getSchoolList: function getSchoolList() {
      var _this6 = this;
      (0, _project.getSchoolList)({
        param: this.prCode
      }).then(function (res) {
        var data = res.data;
        _this6.schoolList = data;
      });
    }
  },
  created: function created() {
    this.getSchoolList();
    this.getAdminList();
  },
  components: {
    ZhjySerach: _zhjySerach.default,
    ZhjyPagination: _zhjyPagination.default,
    FunBtn: _funBtn.default,
    ZhjyTable: _zhjyTable.default
  }
};